import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import linear_as_one_svg from '../../../assets/img/SVG_icons/Top/editing_model/make_edges_linear_as_one.svg';
import { img } from '@phi/components';
import { uid_make_selected_edges_linear_as_one } from '@frontend/ui_display';
import LinearAsOneTooltip from './LinearAsOneTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const LinearAsOneIcon = linear_as_one_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Make edges linear as one';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_sketches
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || this.state.selected_edges_count < 2;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uid_make_selected_edges_linear_as_one();
        },
    },

    render() {
        return h(BarButton, {
            id: 'make-edges-linear-as-one-button',
            onClick: this.onClick,
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 7,
            tippy: 'bottom',
            help: 'make_edges_linear_as_one',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(linear_as_one_svg, this.alt),
            tooltip: LinearAsOneTooltip,
        });
    },
});
